/**
 *
 * @author: Huning
 * @date: 2019-07-11
 *
 */
import React, { PureComponent, Fragment } from 'react'
import { Icon, Tooltip, message } from 'antd'
import PropTypes from 'prop-types'
import style from './index.less'

class ClipBoard extends PureComponent {
  static propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {}

  componentDidMount() {}

  copy = () => {
    this.removeFake()
    const { text } = this.props
    this.fakeElem = document.createElement('textarea')
    this.fakeElem.setAttribute('readonly', '')
    this.fakeElem.value = text
    document.body.appendChild(this.fakeElem)
    this.fakeElem.select()
    document.execCommand('copy')
    this.removeFake()
    message.success(`复制成功：${text}`)
  }

  removeFake = () => {
    if (this.fakeElem) {
      document.body.removeChild(this.fakeElem)
      this.fakeElem = null
    }
  }

  render() {
    const { props, copy } = this
    return (
      <Fragment>
        <Tooltip placement="top" title="点击复制">
          <span className={style['clip-board']} onClick={this.copy}>
            {props.children}
            <Icon style={{ marginLeft: '4px' }} type="copy" />
          </span>
        </Tooltip>
      </Fragment>
    )
  }
}

export default ClipBoard
